// src/components/widgets/CountdownTimer.jsx
import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 12,
    minutes: 0,
    seconds: 0
  })

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const { hours, minutes, seconds } = prev
        
        if (seconds > 0) {
          return { ...prev, seconds: seconds - 1 }
        } else if (minutes > 0) {
          return { hours, minutes: minutes - 1, seconds: 59 }
        } else if (hours > 0) {
          return { hours: hours - 1, minutes: 59, seconds: 59 }
        } else {
          return { hours: 24, minutes: 0, seconds: 0 }
        }
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  return (
    <div className="bg-white/10 rounded-xl p-4">
      <div className="text-sm text-blue-200 mb-2">Next ROI in</div>
      <div className="flex justify-center space-x-3">
        {Object.entries(timeLeft).map(([unit, value]) => (
          <motion.div
            key={unit}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="text-center"
          >
            <div className="bg-white/20 rounded-lg px-3 py-2 min-w-[50px]">
              <div className="text-white font-bold text-lg">
                {value.toString().padStart(2, '0')}
              </div>
            </div>
            <div className="text-xs text-blue-200 mt-1 capitalize">
              {unit}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default CountdownTimer